import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";

// Global Fetch Interceptor
// LOCAL DEV: set VITE_DEV_TOKEN in .env.local → injects as Bearer header
// DEPLOYED:  no VITE_DEV_TOKEN → sends ginja_access_token SSO cookie
const devToken = import.meta.env.VITE_DEV_TOKEN;
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const [resource, config_] = args;
  let config = config_;
  if (!config) config = {};
  if (devToken) {
    config.headers = {
      ...((config.headers as Record<string, string>) || {}),
      Authorization: `Bearer ${devToken}`,
    };
  } else {
    config.credentials = "include";
  }
  return originalFetch(resource as Parameters<typeof originalFetch>[0], config);
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
